import { Option } from '@susu/headless-commerce/features/configurator/domain/Option/Option'
import type { OptionDataAccessObject } from '@susu/headless-commerce/features/configurator/domain/Option/OptionDataAccessObject'
import { ProductEncoder } from '@susu/headless-commerce/features/configurator/domain/Product/ProductEncoder'
import type { Step } from '@susu/headless-commerce/features/configurator/domain/Step/Step'
import type { Configurator } from '../Configurator/Configurator'
import { ProductIdFilterEncoder } from '../Filter/ProductIdFilterEncoder'
import { ProductIdOverrideFilterEncoder } from '../Filter/ProductIdOverrideFilterEncoder'

export class OptionEncoder {
  static encode(instance: Option): OptionDataAccessObject {
    return {
      product: ProductEncoder.encode(instance.product.value),
      // TODO: These methods should be moved to an Encoder.
      recommendations:
        instance.configurator.value.selection.value.encodeToQueryString(
          instance.recommendations.value,
        ),
      thumbnailImage: instance.thumbnailImage.value,
      campaignId: instance.campaignId.value,
      visibility: instance.visibility.value.map(ProductIdFilterEncoder.encode),
      selectionOverride: instance.selectionOverride.value.map(
        ProductIdOverrideFilterEncoder.encode,
      ),
      previewSelectionOverride: instance.previewSelectionOverride.value.map(
        ProductIdOverrideFilterEncoder.encode,
      ),
    }
  }

  static decode(
    configurator: Configurator,
    step: Step,
    properties: OptionDataAccessObject,
  ) {
    const instance = new Option(
      properties.campaignId,
      configurator,
      properties.previewSelectionOverride.map(
        ProductIdOverrideFilterEncoder.decode,
      ),
      ProductEncoder.decode(properties.product),
      // TODO: These methods should be moved to an Encoder.
      configurator.selection.value.decodeFromQueryString(
        properties.recommendations,
      ),
      properties.selectionOverride.map(ProductIdOverrideFilterEncoder.decode),
      step,
      properties.thumbnailImage,
      properties.visibility.map(ProductIdFilterEncoder.decode),
    )

    return instance
  }
}
